import ApiService from '@/common/api.service'

export default {
  async integrationHeirInfo (ankenId) {
    return new Promise((resolve, reject) => {
        ApiService.post('/kintone/getHeirInfo', { 'ankenId': ankenId }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async integrationAssetInfo (ankenId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/kintone/getPropertyInfo', { 'ankenId': ankenId }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDivisionSimulation (ankenId, kintoneFlg) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/division-simulation/${ankenId}?kintoneFlg=${kintoneFlg}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDivisionSimulationDetail (ankenId, simulationId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/division-simulation/${ankenId}/detail/${simulationId}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  putDivisionSimulationDetail (ankenId, simulationId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/division-simulation/${ankenId}/detail/${simulationId}`, data).then(response => {
        resolve(response.data)
      }).catch(error => {
//      console.log(error)
        reject(error)
      })
    })
  },
  removeDivisionSimulationDetail (ankenId, simulationId) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/division-simulation/${ankenId}/detail/${simulationId}/delete`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
